import { defineMessages } from 'react-intl';

export default defineMessages({
	lblFilter: {
		id: 'app.assocAutoComplete.filter',
		defaultMessage: 'Filter',
	},
});
